<template>
  <div>
    <div class="row justify-content-center mb-2">
      <button class="btn btn-add" id="v-step-0" @click="startTour">
        Iniciar Tour de Chamados
      </button>
    </div>
    <v-tour name="myTour" :steps="steps">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step1, index) of tour.steps"
            :key="index"
            :step="step1"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :skip="tour.skip"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <template>
              <div slot="actions">
                <button
                  v-if="tour.currentStep != 0"
                  @click="tour.previousStep"
                  class="btn-step-back"
                >
                  Anterior
                </button>
                <button
                  @click="cancelTour(tour.currentStep)"
                  class="btn-step-back"
                >
                  Pular tour
                </button>
                <button
                  @click="
                    nextTour(
                      tour.currentStep,
                      tour.steps[index + 1],
                      tour.steps[index]
                    )
                  "
                  v-if="tour.currentStep != 11"
                  class="btn-step"
                >
                  Próximo
                </button>
                <button
                  @click="cancelTour(tour.currentStep)"
                  v-else
                  class="btn-step"
                >
                  Finalizar
                </button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
    <div class="card">
      <div class="card-header">
        <div class="card-title">Chamados</div>
      </div>
      <div class="card-body mt-4">
        <div class="row mb-4">
          <div class="col-md-2" align="left">
            <button
              class="btn btn-add"
              type="button"
              id="v-step-3"
              @click="collapseToggle"
            >
              <i class="fas fa-filter"></i> Filtros
            </button>
          </div>
          <div class="col-md-2">
            <button
              class="btn btn-add"
              type="button"
              id="v-step-2"
              @click="getEntity"
            >
              <i class="fas fa-sync-alt"></i> Atualizar
            </button>
          </div>
        </div>

        <div class="row mb-3" v-if="collapse == 1">
          <div class="col-md-6">
            <label id="v-step-4">Filtrar Sala</label>
            <v-select
              :options="rooms"
              label="title"
              :reduce="(rooms) => rooms.id"
              multiple
              class="style-chooser"
              v-model="filters.room_id"
            >
              <div slot="no-options">Nenhum registro encontrado.</div>
            </v-select>
          </div>
          <div class="col-md-6">
            <label id="v-step-5">Filtrar Solicitante</label>
            <v-select
              :options="users"
              label="name"
              :reduce="(users) => users.id"
              multiple
              class="style-chooser"
              v-model="filters.user_id"
            >
              <div slot="no-options">Nenhum registro encontrado.</div>
            </v-select>
          </div>
          <div class="col-md-4 mt-2">
            <label id="v-step-6">Status</label>
            <v-select
              :options="status"
              label="text"
              :reduce="(status) => status.id"
              multiple
              class="style-chooser"
              v-model="filters.status"
            >
              <div slot="no-options">Nenhum registro encontrado.</div>
            </v-select>
          </div>
          <div class="col-md-4 mt-2">
            <label id="v-step-7">Data de Início</label>
            <input
              type="date"
              class="form-control"
              v-model="filters.date_start"
            />
          </div>
          <div class="col-md-4 mt-2">
            <label id="v-step-8">Data Final</label>
            <input
              type="date"
              class="form-control"
              v-model="filters.date_end"
            />
          </div>
          <div class="col-md-12 mt-4 mb-3" align="center">
            <button class="btn btn-add" id="v-step-9" @click="getEntity">
              Pesquisar
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <table class="table" style="font-size: 14px">
              <thead>
                <tr>
                  <th scope="col" id="v-step-10">#</th>
                  <th scope="col">Assunto</th>
                  <th scope="col">Solicitante</th>
                  <th scope="col">Data</th>
                  <th scope="col">Sala/Estação de Trabalho</th>
                  <th scope="col" id="v-step-1">Status</th>
                  <th scope="col" id="v-step-11">Ação</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="ticket in tickets" :key="ticket.id">
                  <td>{{ ticket.id }}</td>
                  <td>{{ ticket.subject }}</td>
                  <td>{{ ticket.opened_by.name }}</td>
                  <td>{{ ticket.created_at }}</td>
                  <td>
                    {{
                      ticket.reserve.room
                        ? ticket.reserve.room.title
                        : ticket.reserve.workstation.title
                    }}
                  </td>
                  <td>
                    <h6>
                      <span
                        v-if="ticket.status == 1"
                        class="badge badge-warning"
                        >Aguardando</span
                      >
                      <span
                        v-if="ticket.status == 2"
                        class="badge badge-primary"
                        >Em andamento</span
                      >
                      <span
                        v-if="ticket.status == 3"
                        class="badge badge-success"
                        >Finalizado</span
                      >
                    </h6>
                  </td>
                  <td>
                    <router-link
                      class="btn btn-add"
                      :to="'/tickets/manage/' + ticket.id"
                    >
                      <i class="fas fa-eye"></i>
                    </router-link>
                  </td>
                </tr>
                <tr v-if="tickets.length == 0">
                  <td colspan="8" align="center">
                    Nenhum registro encontrado.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12">
            <pagination
              :records="total"
              :options="options"
              :per-page="10"
              @paginate="getEntity"
            ></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { Pagination } from "vue-pagination-2";
export default {
  data: function () {
    return {
      steps: [
        {
          target: "#v-step-0", // We're using document.querySelector() under the hood
          header: {
            title: "Tela de Chamados",
          },
          params: {
            enableScrolling: false,
          },
          content: `Clique em <strong>próximo</strong> para continuar no tour. Caso não queira esse acompanhamento, clique em <strong>Pular tour</strong>. Se preferir poderá ver esse tour guiado a qualquer momento no botão destacado no menu superior.`,
        },
        {
          target: "#v-step-1",
          params: {
            enableScrolling: false,
            placement: "top",
          },
          content:
            "Por padrão deixamos um filtro automático com o Status: Aguardando e Em Andamento. Então se caso já existir algum Chamado com esses status, ele iŕa aparecer sem necessidade de filtro. ",
        },
        {
          target: "#v-step-2",
          params: {
            enableScrolling: false,
            placement: "top",
          },
          content:
            "Aqui temos alguns Filtros para podermos buscar um Chamado desejado.",
        },
        {
          target: "#v-step-3",
          params: {
            enableScrolling: false,
          },
          content: "Clique em Filtros para seguirmos com o tour.",
        },
        {
          target: "#v-step-4",
          params: {
            enableScrolling: false,
          },
          content: "Filtramos pela Sala de Reunião",
        },
        {
          target: "#v-step-5",
          params: {
            enableScrolling: false,
          },
          content: "Filtramos pelo Solicitante deste Chamado",
        },
        {
          target: "#v-step-6",
          params: {
            enableScrolling: false,
          },
          content: "Pelo Status do Chamado",
        },
        {
          target: "#v-step-7",
          params: {
            enableScrolling: false,
          },
          content: "Pela Data de ínicio do Chamado",
        },
        {
          target: "#v-step-8",
          params: {
            enableScrolling: false,
          },
          content: "Pela Data Final do Chamado",
        },
        {
          target: "#v-step-9",
          params: {
            enableScrolling: false,
          },
          content:
            "E clique em Pesquisar, e abaixo irá exibir os chamados com base nos filtros.",
        },
        {
          target: "#v-step-10",
          params: {
            enableScrolling: false,
            placement: "top",
          },
          content: "Aqui temos os resultados dos filtros",
        },
        {
          target: "#v-step-11",
          params: {
            enableScrolling: false,
            placement: "top",
          },
          content:
            "Se houver algum chamado clique em <i class='fas fa-eye'></i> para você ir para uma outra página para ter mais detalhes deste chamado. Na outra página teremos um novo tour se necessário.",
        },
      ],
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
      users: [],
      total: 0,
      page: 1,
      collapse: 0,
      tickets: [],
      rooms: [],
      filters: {
        status: [1, 2],
      },
      dataModal: null,
      status: [
        {
          id: 1,
          text: "Aguardando",
        },
        {
          id: 2,
          text: "Em andamento",
        },
        {
          id: 3,
          text: "Finalizado",
        },
      ],
    };
  },
  components: { vSelect, Pagination },
  methods: {
    cancelTour(step) {
      const self = this;
      self.$tours["myTour"].skip();
      self.$store.commit("skipTour");

      let data = { finished_step: step };

      const api = self.$store.state.api + "user/finish-tour";

      self.$http.post(api, data).then((response) => {});
    },
    nextTour(step, actual_target, previous_target) {
      const self = this;

      if (step >= 31) {
        if (step >= 31) {
          $(previous_target.target).toggleClass("activeMenu");
        }
        $(actual_target.target).toggleClass("activeMenu");
      }

      if (step == 2) {
        this.collapseToggle();
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 31) {
        $("#pagCads").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 31) {
        $("#sidebar").toggleClass("active");
        $("html, body").animate({ scrollTop: 0 }, 0);
        self.$tours["myTour"].nextStep();
      } else {
        self.$tours["myTour"].nextStep();
      }
    },
    startTour() {
      let self = this;
      self.$tours["myTour"].start();
    },
    getEntity(page) {
      const self = this;
      self.page = page ? page : self.page;
      const api = self.$store.state.api + "tickets/manage/?page=" + self.page;

      self.$http
        .post(api, self.filters)
        .then((response) => {
          self.tickets = response.data.data;
          self.total = response.data.total;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    collapseToggle() {
      if (this.collapse == 1) {
        this.collapse = 0;
      } else {
        this.collapse = 1;
      }
    },
    changeStatus(status) {
      const self = this;
      const api = self.$store.state.api + "services_additionals/change-status";

      self.$http
        .post(api, { additional_id: self.dataModal.id, status: status })
        .then(() => {
          self.getEntity();
          self.$message(
            "Sucesso",
            "Adicional atualizado com sucesso",
            "success"
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getRooms: function () {
      const self = this;
      const api = self.$store.state.api + "rooms?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.rooms = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUsers: function () {
      const self = this;
      const api = self.$store.state.api + "users?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.users = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted() {
    this.getEntity();
    this.getRooms();
    this.getUsers();
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Tickets/Crud.vue